require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/common/location.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/common/location.legacy.js
// module id = 636
// module chunks = 31